<script lang="ts">
    import EmployeeWidget from "$lib/partials/EmployeeWidget.svelte";
    import {Badge, Label} from "flowbite-svelte";
    import EmployeeFormGroup from "$lib/partials/EmployeeFormGroup.svelte";
    import {onMount} from "svelte";

    export let editing = false;
    export let employee = {};

    let bankDetails = {};

    function getBankDetails() {
        if(! employee.bankAccount) {
            employee.bankAccount = {};
        }
        fetch(`https://openiban.com/validate/${employee.bankAccount.iban}?getBIC=true&validateBankCode=true`).then(j => j.json()).then(j => {
            bankDetails = j
        })
    }
    onMount(() => {
        getBankDetails()
    })
</script>

<EmployeeWidget headline="Zahlungsart" collapsible open={false}>

    <svelte:fragment slot="left">

        <EmployeeFormGroup
                {editing}
                label="Kontoinhaber"
                labelFor="Kontoinhaber"
                bind:value={employee.bankAccount.accountName}
                divideRatio="1/3">
            {employee.bankAccount.accountName || ''}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="IBAN"
                labelFor="iban"
                bind:value={employee.bankAccount.iban}
                divideRatio="1/3">
            {employee.bankAccount.iban || ''}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="BIC/SWIFT"
                labelFor="bic"
                bind:value={employee.bankAccount.bicSwift}
                divideRatio="1/3">
            {employee.bankAccount.bicSwift || ''}
        </EmployeeFormGroup>

    </svelte:fragment>
    <svelte:fragment slot="right">
        <div class="mt-8 format">
            <Badge color={bankDetails.valid ? 'green' : 'red'}>{bankDetails.valid ? 'gültig' : 'nicht verifizierbar'}</Badge>
            <p>{bankDetails?.bankData?.name}</p>
            <p>{bankDetails?.bankData?.zip} {bankDetails?.bankData?.city}</p>
            <p>BIC: {bankDetails?.bankData?.bic}</p>
        </div>

    </svelte:fragment>

</EmployeeWidget>